"use strict";

exports.__esModule = true;
exports.TicketScreenToolbar = TicketScreenToolbar;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _System = require("../../../System");
var _Calendar = require("../../Calendar");
var _Auth = require("../../Auth");
var _MultiDeviceSelector = require("../../Device/MultiDeviceSelector/MultiDeviceSelector");
var _Core = require("../../Core");
var _URLFilter = require("../../Core/URLFilter");
var _ReportingPeriod = require("../../Time/ReportingPeriod");
var _Device = require("../../Device");
var _Time = require("../../Time");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Left = _styledComponents["default"].div.withConfig({
  displayName: "TicketScreenToolbar__Left",
  componentId: "sc-1xohmag-0"
})(["display:flex;flex-direction:row;> span{padding:0 0.2rem;}"]);
var Right = (0, _styledComponents["default"])(_core.ControlGroup).withConfig({
  displayName: "TicketScreenToolbar__Right",
  componentId: "sc-1xohmag-1"
})(["display:flex;flex-direction:row;flex-flow:row-reverse;> span{padding:0 0 0 0.2rem;}"]);
var TicketToolbar = (0, _styledComponents["default"])(_Core.Toolbar).withConfig({
  displayName: "TicketScreenToolbar__TicketToolbar",
  componentId: "sc-1xohmag-2"
})(["display:flex;min-width:980px;"]);
function TicketScreenToolbar(props) {
  var style = props.style,
    devices = props.devices;
  var urlFilter = _react["default"].useContext(_URLFilter.URLFilterContext);
  var reportingPeriod = _react["default"].useContext(_ReportingPeriod.ReportingPeriodContext);
  var deviceTags = _react["default"].useContext(_Device.DeviceTagListContext);
  var _React$useContext = _react["default"].useContext(_Calendar.CalendarContext),
    calendar = _React$useContext.calendar;
  var time = _react["default"].useContext(_Time.TimeContext);
  var currentPlantWorkdayId = (0, _Calendar.getDate)(time.currentWorkday.interval.endMillis);
  var filters = urlFilter.filters,
    setFilter = urlFilter.setFilter;
  var start = (0, _Calendar.startOfDay)(calendar.getWorkdayAt(reportingPeriod.interval.startMillis).id);
  var end = (0, _Calendar.endOfDay)(calendar.getWorkdayAt(reportingPeriod.interval.endMillis - 1).id);
  return /*#__PURE__*/_react["default"].createElement(TicketToolbar, {
    "data-testid": "TicketScreenToolbar",
    style: style
  }, /*#__PURE__*/_react["default"].createElement(Left, null, /*#__PURE__*/_react["default"].createElement(_MultiDeviceSelector.MultiDeviceSelector, {
    style: {
      maxWidth: 200
    },
    devices: devices,
    tags: deviceTags,
    selectAllByDefault: true,
    sel: true,
    selected: filters.device,
    onSelect: function onSelect(devices) {
      return setFilter("device", devices.map(function (device) {
        return device.uuid;
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_Time.WorkdayRangeSelector, {
    maxDate: currentPlantWorkdayId,
    selected: [start, end],
    onSelect: function onSelect(selected) {
      if (selected.length === 0) {
        return;
      }

      // This can result in the days incrementing/decrementing from what the user selected
      var interval = calendar.getIntervalForWorkdays((0, _Calendar.toDateString)(selected));
      var parts = [new Date(interval.startMillis).toISOString(), new Date(interval.endMillis).toISOString()];
      return setFilter("period", parts.join("/"));
    }
  })), /*#__PURE__*/_react["default"].createElement(Right, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, null, /*#__PURE__*/_react["default"].createElement(_Auth.HasAccess, {
    permission: "CONFIGURE_TICKETING"
  }, /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
    to: (0, _System.getScreenURL)("TicketTypes"),
    icon: _icons.IconNames.TAG,
    minimal: true,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TicketToolbar.buttons.ManageTicketTypes.label",
      defaultMessage: " Ticket Types"
    })
  }), /*#__PURE__*/_react["default"].createElement(_Core.LinkButton, {
    to: (0, _System.getScreenURL)("TicketWatcherRuleList"),
    icon: _icons.IconNames.ISSUE,
    minimal: true,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "TicketToolbar.buttons.ManageTicketWatcherRules.label",
      defaultMessage: "Ticket Watcher Rules"
    })
  })))));
}